<template>
  <el-header class="navbar">
    <div class="navbar-left">
      <div class="logo">
        <div class="logo-icon"><img src="@/assets/images/logo.png" width="100%" height="100%"/></div>
        <span class="logo-text">智瞰·项目雷达（广东版） | 企业级商业情报智能分析平台</span>
      </div>
    </div>
    
    <!-- 用户登录状态区域 -->
    <div class="navbar-right">
      <el-dropdown 
        trigger="hover" 
        placement="bottom-end"
        @visible-change="handleVisibleChange"
      >
        <div class="user-profile" :class="{ 'is-active': dropdownVisible }">
          <div class="avatar">
            <i class="el-icon-user-solid"></i>
          </div>
          <div class="user-info">
            <span class="user-phone">{{ userdata.username }}</span>
            <!-- <span class="user-type">个人版</span> -->
          </div>
          <i class="el-icon-arrow-down arrow-icon"></i>
        </div>
        
        <el-dropdown-menu slot="dropdown" class="user-dropdown-menu">
          <!-- 用户信息卡片 -->
          <div class="dropdown-header">
            <div class="dropdown-avatar">
              <i class="el-icon-user-solid"></i>
            </div>
            <div class="dropdown-user-info">
              <div class="dropdown-phone">{{ userdata.username }}</div>
              <!-- <div class="dropdown-type">个人版</div> -->
            </div>
          </div>
          
          <!-- <el-dropdown-item divided>
            <i class="el-icon-lock"></i>
            <span>账号与安全</span>
          </el-dropdown-item> -->
          
          <el-dropdown-item>
            <i class="el-icon-postcard"></i>
            <span @click="routerself('/editPassWord')">修改密码</span>
          </el-dropdown-item>
          
          <el-dropdown-item>
            <i class="el-icon-switch-button"></i>
            <span @click="loginOut()">退出登录</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </el-header>
</template>

<script>
export default {
  name: 'NavBar',
  data() {
    return {
      userdata: {username: ''},
      phone: '186****5185',
      dropdownVisible: false
    }
  },
  computed: {
    maskedPhone() {
      // 如果手机号是明文，自动脱敏处理
      if (this.phone && this.phone.length === 11) {
        return this.phone.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2')
      }
      return this.phonez
    }
  },
  mounted() {
    this.userdata = this.getuseriformation() || {};
  },
  
  methods: {
    handleVisibleChange(visible) {
      this.dropdownVisible = visible
    }
  }
}
</script>

<style scoped lang="scss">
.navbar {
  height: 60px !important;
  background: linear-gradient(135deg, #1e3a5f 0%, #2d5a87 100%);
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
}

.navbar-left {
  display: flex;
  align-items: center;
}

.logo {
  display: flex;
  align-items: center;
  gap: 12px;
}

.logo-icon {
  width: 36px;
  height: 36px;
  background: #3b82f6;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-weight: bold;
  font-size: 18px;
  img{
    border-radius: 10px;
  }
}

.logo-text {
  color: white;
  font-size: 18px;
  font-weight: 500;
}

/* 用户资料样式 */
.navbar-right {
  display: flex;
  align-items: center;
}

.user-profile {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 6px 12px;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  background: rgba(255, 255, 255, 0.1);
}

.user-profile:hover,
.user-profile.is-active {
  background: rgba(255, 255, 255, 0.2);
}

.avatar {
  width: 32px;
  height: 32px;
  background: #00b4d8;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 16px;
}

.user-info {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  line-height: 1.2;
}

.user-phone {
  color: white;
  font-size: 14px;
  font-weight: 500;
}

.user-type {
  color: rgba(255, 255, 255, 0.7);
  font-size: 12px;
}

.arrow-icon {
  color: rgba(255, 255, 255, 0.7);
  font-size: 12px;
  transition: transform 0.3s ease;
}

.user-profile.is-active .arrow-icon {
  transform: rotate(180deg);
}

/* 下拉菜单样式 */
.user-dropdown-menu {
  padding: 0;
  min-width: 220px;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
}

.dropdown-header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px;
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
}

.dropdown-avatar {
  width: 44px;
  height: 44px;
  background: #00b4d8;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 20px;
}

.dropdown-user-info {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.dropdown-phone {
  color: #1e293b;
  font-size: 15px;
  font-weight: 600;
}

.dropdown-type {
  color: #64748b;
  font-size: 12px;
}

/* 下拉菜单项样式 */
.user-dropdown-menu .el-dropdown-menu__item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 0 12px 23px;
  font-size: 14px;
  color: #334155;
  transition: all 0.2s ease;
}

.user-dropdown-menu .el-dropdown-menu__item i {
  font-size: 16px;
  color: #64748b;
}

.user-dropdown-menu .el-dropdown-menu__item:hover {
  background-color: #f1f5f9;
  color: #0ea5e9;
}

.user-dropdown-menu .el-dropdown-menu__item:hover i {
  color: #0ea5e9;
}

.user-dropdown-menu .el-dropdown-menu__item--divided {
  border-top: 1px solid #e2e8f0;
  margin-top: 0;
}

.user-dropdown-menu .el-dropdown-menu__item--divided:before {
  height: 0;
  margin: 0;
}
</style>